import { CustomersFilterForm } from "./filters"
import { CustomersTable } from "./table"

export const Customers = () => {
  return (
    <div className="flex flex-1 flex-col gap-4">
      <CustomersFilterForm />
      <CustomersTable />
    </div>
  )
}
